import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import { Dialog, Button, Dropdown, TextInput, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import errorIcon from "@icons/ic-error.svg";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  ErrorDiv,
  RequiredMessage,
} from "./AddEditGeneralParameter.styled";
import closeIcon from "@icons/ic-close-white.svg";

const AddEditGeneralParameter = (props) => {
  const {
    t,
    id,
    isEditMode,
    onClose,
    updateRefeshStatus,
    selectedParam,
  } = props;

  const [isParamCreating, setIsParamCreating] = useState(false);
  const [createParamAPIError, setCreateParamAPIError] = useState("");
  const [codeExistError, setCodeExistError] = useState("");

  const generalParams = useGetGeneralParameters();

  const { countryList } = generalParams;
  const sortedCountryList = [...countryList]
    .sort((a, b) => a.label.localeCompare(b.label))
    .filter((country) => country.platform === 1);

    const countryOptions = [
      {
        label: t("ALL"), value: "",
      },
      ...sortedCountryList,
    ];
  const [formData, setFormData] = useState({
    code: {
      required: true,
      value: selectedParam?.code ?? "",
      error: "",
    },
    value: {
      required: true,
      value: selectedParam?.value ?? "",
      error: "",
    },
    description: {
      required: true,
      value: selectedParam?.description ?? "",
      error: "",
    },
    country: {
      required: true,
      value: selectedParam?.country?.id ?? "",
      error: "",
    },
    isActive: {
      required: true,
      value: selectedParam?.isActive ?? true,
      error: "",
    },
  });

  const onFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value,
        error: "",
        required: true,
      },
    }));
    if (["code", "country"].includes(field)) setCodeExistError("");
  };

  const validateForm = (data) => {
    let isFormValid = true;
    if (!data.code.value) {
      isFormValid = false;
      data.code.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.value.value) {
      isFormValid = false;
      data.value.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!data.description.value) {
      isFormValid = false;
      data.description.error = t("GENERAL_MANDATORY_ERROR");
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }

    return isFormValid;
  };

  async function checkCodeExist() {
    setCodeExistError("");
    const response = await axios.get(
      `/general/countryParameters?codes=["${formData.code.value}"]&country=${formData.country.value}`
    );
    return response.data;
  }

  const getFormData = () => {
    const data = {
      id: isEditMode ? id : "",
      code: formData.code.value,
      description: formData.description.value,
      value: formData.value.value,
      isActive: formData.isActive.value,
      country: {id:formData.country.value},
    };
    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      checkCodeExist().then((response) => {
        console.log("response", response?.countryParameters?.length);
        console.log("response", isEditMode);
        console.log("response", response?.countryParameters[0]?.id);
        console.log("response", id);
        if (
          response?.countryParameters?.length === 0 ||
          (isEditMode &&
            response?.countryParameters?.length === 1 &&
            response?.countryParameters?.[0]?.id === id)
        ) {
          setIsParamCreating(true);
          setCreateParamAPIError("");
          const payload = getFormData();
          const request = isEditMode
            ? axios.put(`/general/countryParameters/${id}`, payload)
            : axios.post("/general/countryParameters ", payload);
          request
            .then((response) => {
              setIsParamCreating(false);
              updateRefeshStatus();
              onClose();
            })
            .catch((error) => {
              setIsParamCreating(false);
              setCreateParamAPIError(error.response?.data?.message ?? "");
            });
        } else {
          setCodeExistError("GENERAL_PARAMETER_DUPLICATE_ERROR");
        }
      });
    }
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>
            {isEditMode
              ? t("GENERAL_PARAMETER") + " " + selectedParam?.code
              : t("GENERAL_PARAMETER_NEW")}
          </Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow column="1fr 1fr">
                    <div className="add-enquiry__dropdown">
                      <Dropdown
                        placeholder={t("COUNTRY")}
                        label={t("COUNTRY")}
                        value={formData.country.value}
                        options={countryOptions}
                        error={formData.country.error}
                        onChange={(option) =>
                          onFormChange("country", option.value)
                        }
                        labelStyles={
                          formData.country.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputClass={
                          formData.country.error !== ""
                            ? "dropdown-with-search__dropdown-input-error"
                            : "dropdown-with-search__dropdown-input"
                        }
                      />
                    </div>
                  </GridRow>
                  <GridRow column="1fr 1fr">
                    <TextInput
                      id="param_code"
                      type="text"
                      label={t("CODE")}
                      isFloat
                      required
                      value={String(formData.code.value)}
                      onChange={(e) => onFormChange("code", e.target.value)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.code.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.code.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.code.error}
                      placeholder={t("GENERAL_PARAMETER_FORM_CODE_PLACEHOLDER")}
                    />

                    <TextInput
                      id="param_value"
                      type="text"
                      label={t("VALUE")}
                      isFloat
                      required
                      value={String(formData.value.value)}
                      onChange={(e) => onFormChange("value", e.target.value)}
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.value.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.value.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.value.error}
                      placeholder={t(
                        "GENERAL_PARAMETER_FORM_VALUE_PLACEHOLDER"
                      )}
                    />
                  </GridRow>
                  <GridRow column="1fr">
                    <TextInput
                      id="param_desciption"
                      type="textarea"
                      label={t("DESCRIPTION")}
                      isFloat
                      required
                      value={String(formData.description.value)}
                      onChange={(e) =>
                        onFormChange("description", e.target.value)
                      }
                      containerStyles={{ marginTop: "21px" }}
                      errorStyles={{ "font-style": "italic" }}
                      labelStyles={
                        formData.description.error !== ""
                          ? labelStylesError
                          : labelStyles
                      }
                      inputStyles={
                        formData.description.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                      error={formData.description.error}
                      placeholder={t(
                        "GENERAL_PARAMETER_FORM_DESCRIPTION_PLACEHOLDER"
                      )}
                    />
                  </GridRow>
                  {codeExistError !== "" && (
                    <GridRow column="1fr">
                      <ErrorDiv>
                        <RequiredMessage>
                          <Image
                            src={errorIcon}
                            alt="warning"
                            styles={{ width: "18px" }}
                          />{" "}
                          {t(codeExistError)}
                        </RequiredMessage>
                      </ErrorDiv>
                    </GridRow>
                  )}
                </div>
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>

        <ButtonWrapper>
          {createParamAPIError && <div>{createParamAPIError}</div>}
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isParamCreating && <ClipLoader size={15} color="#fff" />}
              {!isParamCreating && t("SAVE")}
            </>
          </Button>

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CANCEL")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditGeneralParameter.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
};

AddEditGeneralParameter.defaultProps = {
  id: null,
  isEditMode: false,
};
export default withTranslation()(AddEditGeneralParameter);
